import {
  STORE_USER,
  LOADING_AUTHENTICATION,
} from '../types';

export const storeUser = (user, isAuthorizedUser) => ({
  type: STORE_USER,
  user,
  isAuthorizedUser,
});

export const loadingAuthentication = () => ({
  type: LOADING_AUTHENTICATION,
});
